"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cube = void 0;
var gsap_1 = require("gsap");
var three_1 = require("three");
var function_1 = require("../util/function");
var Cube = /** @class */ (function () {
    function Cube(base) {
        this.base = base;
        this.setModel();
    }
    Cube.prototype.createRoundedBoxGeo = function (width, height, depth, radius0, smoothness) {
        var shape = new three_1.Shape();
        var eps = 0.00001;
        var radius = radius0 - eps;
        var faceRadius = 0.25;
        shape.absarc(eps, eps, faceRadius, -Math.PI / 2, -Math.PI, true);
        shape.absarc(eps, height - radius * 2, faceRadius, Math.PI, Math.PI / 2, true);
        shape.absarc(width - radius * 2, height - radius * 2, faceRadius, Math.PI / 2, 0, true);
        shape.absarc(width - radius * 2, eps, faceRadius, 0, -Math.PI / 2, true);
        var geometry = new three_1.ExtrudeGeometry(shape, {
            depth: depth - radius0,
            bevelEnabled: true,
            bevelSegments: smoothness * 2,
            steps: 1,
            bevelSize: radius,
            bevelThickness: radius0,
            curveSegments: smoothness
        });
        geometry.center();
        return geometry;
    };
    Cube.prototype.setModel = function () {
        var _a, _b;
        var geo = this.createRoundedBoxGeo(3, 3, 3, 0.4, 20);
        var mat = new three_1.MeshMatcapMaterial({
            matcap: this.base.resources.cubeMatcap
        });
        this.group = new three_1.Group();
        this.mesh = new three_1.Mesh(geo, mat);
        (_a = this.mesh.scale).set.apply(_a, function_1.cubeLikeConfig.initialScale);
        (_b = this.mesh.rotation).set.apply(_b, function_1.cubeLikeConfig.initialRotation);
        this.group.add(this.mesh);
        this.base.scene.add(this.group);
        this.doAnimation();
    };
    Cube.prototype.doAnimation = function () {
        gsap_1.default.to(this.mesh.rotation, function_1.cubeLikeConfig.startAnimationInnerRotationConfig);
        gsap_1.default.to(this.mesh.scale, function_1.cubeLikeConfig.startAnimationInnerScalingConfig);
    };
    Cube.prototype.showChat = function () {
        var _this = this;
        gsap_1.default.to(this.base.camera.instance.position, {
            x: this.base.camera.bestPoint.x,
            y: this.base.camera.bestPoint.y,
            z: this.base.camera.bestPoint.z,
            duration: 4,
            onStart: function () {
                _this.base.camera.controls.enabled = false;
                _this.base.camera.controls.enableDamping = false;
            },
            onComplete: function () {
                _this.base.camera.controls.enabled = true;
                _this.base.camera.controls.enableDamping = true;
            }
        });
        gsap_1.default.to(this.mesh.rotation, function_1.cubeLikeConfig.showChatAnimationInnerRotationConfig);
        var angle = (0, function_1.getTargetAngle)(this.group.rotation.y);
        gsap_1.default.to(this.group.rotation, {
            x: 0,
            y: angle,
            z: 0,
            duration: 2
        });
    };
    Cube.prototype.showMusic = function () {
        var _this = this;
        gsap_1.default.to(this.base.camera.instance.position, {
            x: this.base.camera.bestPoint.x,
            y: this.base.camera.bestPoint.y,
            z: this.base.camera.bestPoint.z,
            duration: 4,
            onStart: function () {
                _this.base.camera.controls.enabled = false;
                _this.base.camera.controls.enableDamping = false;
            },
            onComplete: function () {
                _this.base.camera.controls.enabled = true;
                _this.base.camera.controls.enableDamping = true;
            }
        });
        gsap_1.default.to(this.mesh.rotation, function_1.cubeLikeConfig.showMusicAnimationInnerRotationConfig);
        var angle = (0, function_1.getTargetAngle)(this.group.rotation.y);
        gsap_1.default.to(this.group.rotation, {
            x: 0,
            y: angle - Math.PI / 4,
            z: 0,
            duration: 2
        });
    };
    Cube.prototype.update = function (delta) {
        if (!this.base.touched && !this.base.getRotationLockStatus()) {
            this.group.rotation.y += delta / function_1.cubeLikeConfig.updateParameter;
        }
    };
    return Cube;
}());
exports.Cube = Cube;
